module.exports = __webpack_public_path__ + "media/images/delivery-b4aaa8c3cd7a1c42246848a46fa284a6.png";